import { Pipe, PipeTransform } from '@angular/core';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'syndicateproduct',
    pure: true,
    standalone: true
})
export class SyndicateproductPipe implements PipeTransform {

  transform(syndicateProduct: any): any {
    let syndicateData = []
    syndicateProduct.map(data => {
      data?.draw_day.map((day) => {
        syndicateData.push({ image_url: data?.image_url, product_name: data?.product_name, total_lines: data?.total_lines, draw_day: day })

      })
    })


    return syndicateData;
  }

}
